import { useContext } from "react";
import { HeroStrings } from "../consts/strings";
import SectionWrapper from "../hoc/SectionWrapper";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Hero = () => {
  const { auth } = useContext(AuthContext);
  return (
    <>
      <div className="max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-6xl xl:max-w-[85rem] mx-auto overflow-y-visible">
        <div
          aria-hidden="true"
          className="flex absolute -top-96 start-1/2 transform -translate-x-1/2 z-[-1] w-screen overflow-y-visible justify-center h-screen"
        >
          <div className="bg-gradient-to-r from-amber-200/50 to-amber-100 blur-3xl w-[100rem] md:w-[44rem] h-[50rem] md:h-[60rem] lg:h-[50rem] rotate-[-60deg] transform -translate-x-[10rem]  /50  "></div>
          <div className="bg-gradient-to-tl from-amber-200/50 via-amber-100 to-purple-50 blur-3xl w-[100rem] md:w-[44rem] h-[50rem] md:h-[60rem] lg:h-[50rem] rounded-fulls origin-top-left -rotate-12 -translate-x-[15rem]  /70  /70  /70"></div>
        </div>
        <h1 className="mt-4 text-3xl font-bold text-gray-900 sm:text-4xl md:text-5xl lg:text-6xl">
          {HeroStrings.header}
        </h1>
        <div className="flex flex-col md:flex-row gap-x-5 lg:gap-x-8 xl:gap-x-12 pt-5">
          <div className="gap-y-8 w-full md:w-4/5">
            <p className="mt-4 text-lg text-gray-800   break-after-left w-full ">
              {HeroStrings.paragraph}
            </p>
            <div className="mt-4 flex flex-row gap-x-4">
              <Link to="/nova-pozivnica">
                <button
                  type="button"
                  className="before:ease relative h-12 w-40 overflow-hidden shadow-2xl shadow-amber-400 border border-amber-300 bg-amber-300 font-semibold text-black rounded-md p-3 transition-all before:absolute before:right-0 before:top-0 before:h-12 before:w-6 before:translate-x-12 before:rotate-6 before:bg-white before:opacity-15 before:duration-700 hover:before:-translate-x-40"
                >
                  {HeroStrings.createRsvpButton}
                </button>
              </Link>

              {auth?.isAuthenticated ? (
                <Link to="/moje-pozivnice">
                  <button
                    type="button"
                    className="h-12 w-40 overflow-hidden shadow-2xl shadow-amber-400 border border-amber-300 font-semibold text-black rounded-md p-3"
                  >
                    {HeroStrings.myRsvps}
                  </button>
                </Link>
              ) : (
                <Link to="/auth">
                  <button
                    type="button"
                    className="h-12 w-40 overflow-hidden shadow-2xl shadow-amber-400 border border-amber-300 font-semibold text-black rounded-md p-3"
                  >
                    {HeroStrings.loginButton}
                  </button>
                </Link>
              )}
            </div>
          </div>
          <div className="overflow-hidden pt-10 md:pt-0 overflow-y-visible w-full h-full">
            <div>
              <picture>
                <source
                  srcSet="https://pozivnica.hr/cdn-cgi/image/width=600,quality=80,format=auto/https://bucket.pozivnica.hr/pozivnica/mockup.webp"
                  media="(max-width: 768px)"
                  type="image/webp"
                />
                <source
                  srcSet="https://pozivnica.hr/cdn-cgi/image/width=600,quality=80,format=auto/https://bucket.pozivnica.hr/pozivnica/mockup.webp"
                  media="(min-width: 769px)"
                  type="image/webp"
                />
                <img
                  src="https://pozivnica.hr/cdn-cgi/image/width=1200,quality=80,format=auto/https://bucket.pozivnica.hr/pozivnica/mockup.webp"
                  alt="Pozivnica Mockup"
                  width="1200px"
                  height="920px"
                  className="w-full"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionWrapper(Hero, "");
